module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_B.ceee4eec.mp3";